import { Group, Select, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { alphaNumericRegex, descriptionRegex } from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";

export const AddEducationEssentials = ({
  opened,
  setOpened,
  lookupsTypes,
  setUpdate,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  console.log("lookupsTypes", lookupsTypes);
  const lookUpLists = lookupsTypes?.map((lookupType) => ({
    label: lookupType,
    value: lookupType,
  }));
  console.log("hiii", lookUpLists);
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      lookupType: "",
      name: "",
      description: "",
    },

    validate: {
      lookupType: (value) =>
        value ? null : "Please select a valid industry type",

      name: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Alphabetic Name with 2 or more characters",
      description: (value) =>
        value?.trim()?.length > 1 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
    },
  });
  useEffect(() => {
    if (editModalState) {
      form.setValues({
        lookupType: editData.lookupType,
        name: editData.lookupName,
        description:
          editData.lookupDescription || "This is a Sample description",
      });
    }
  }, [opened]);

  const onSubmit = (values) => {
    let url = "";
    if (form.values.lookupType === "degree") {
      console.log("we are in degree if");
      values.degreeName = values.name;
      values.degreeNote = values.description;
      console.log("values1", values);
      if (!editModalState) {
        url = "degree/addDegree";
      } else {
        values.degreeId = editData._id;
        url = "degree/editDegree";
      }
    }
    console.log("values of url", url);
    if (form.values.lookupType === "major") {
      values.majorName = values.name;
      values.majorDescription = values.description;
      console.log("values2", values);
      if (!editModalState) {
        url = "major/addMajor";
      } else {
        values.majorId = editData._id;
        url = "major/editMajor";
      }
    } else if (
      form.values.lookupType !== "degree" &&
      form.values.lookupType !== "major"
    ) {
      values.lookupName = values.name;
      values.lookupDescription = values.description;
      console.log("values3", values);
      if (!editModalState) {
        url = "lookup/addLookup";
      } else {
        values.lookupId = editData._id;
        url = "lookup/editLookup";
      }
      console.log("values4", url);
    }
    if (editModalState) {
      setEditData({});
      setEditModalState(false);
    }
    form.reset();
    setLoading(true);
    addAndEditData(values, setOpened, setUpdate, url);
  };
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        Type
      </Text>
      <Select
        styles={{
          input: {
            padding: "1.2rem",
          },
        }}
        required
        withAsterisk={false}
        placeholder="Select Type"
        data={lookUpLists}
        // searchable
        nothingFound="No Industry Type found"
        {...form.getInputProps("lookupType")}
      />
      <Text mt="lg" mb={0} weight={500}>
        Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter Name"
        form={form}
        validateName="name"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />
      <Text mt="lg" mb={0} weight={500}>
        Description
      </Text>
      <DescriptionField
        width="100%"
        placeholder="Enter Description"
        form={form}
        validateName="description"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Edit" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );

  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title={
        editModalState
          ? "Edit Education Essentials"
          : "Add Education Essentials"
      }
      form={form}
      setEditData={setEditData}
      setEditModalState={setEditModalState}
      addEdit={true}
    />
  );
};
